module.exports = __webpack_public_path__ + "media/newstyle/images/icon-a5-3850917e94c84ce5eb11b9c1ce1078a4.svg";